<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive :include="cachedViews"> -->
        <router-view :key="key" />
      <!-- </keep-alive> -->
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return null
    },
    key() {
      // console.log(this.$route)
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

